import { buildScopedI18n } from '../../utils/buildScopedI18n';
import legalCasesEsCL from './locales/es-CL.json';
import legalCasesEnUS from './locales/en-US.json';
import legalCasesPtBR from './locales/pt-BR.json';

export const legalCasesI18n = buildScopedI18n({
  esCL: legalCasesEsCL,
  enUS: legalCasesEnUS,
  ptBR: legalCasesPtBR,
});
